module.exports = __webpack_public_path__ + "static/media/customers.37931d46.svg";